/**
 * This dashboard is org-scoped: almost every route sits under /:orgId. The
 * active organization is kept in localStorage, and auth screens are reachable
 * both with and without it, so paths are built through here rather than
 * repeating the same conditional in every component.
 */
export const orgPath = (suffix: string): string => {
  const activeOrgId = window.localStorage.getItem('active-org-id');
  return activeOrgId ? `/${activeOrgId}${suffix}` : suffix;
};

export const orgUrl = (suffix: string): string =>
  `${window.location.origin}${orgPath(suffix)}`;
